import {translate} from 'vue-gettext'

const {pgettext: $pgettext} = translate


export const popoverEventWizard = {
    activateEvent: {
        header: () => $pgettext('event.tooltip', 'Activate event') + '<span class="p-closer j-activate-event">&times;</span>',
        content: () => $pgettext('event.tooltip', 'Confirm the chosen package and after activating the event you will be able to upload all the photos. In the overview section you will find the direct link and the QR code to communicate to participants to access their photo album.'),
        appendToBody: false,
        active: true,
        placement: 'top-start',
    },
    activateEventPriceListRequired: {
        header: () => $pgettext('event.tooltip', 'Create price lists') + '<span class="p-closer j-activate-event">&times;</span>',
        content: ({picaServiceId, galleryId} = {}) => {
            const text = $pgettext('event.tooltip', "Before activating the event, set the sales price list by clicking %{link}")
            const link = `<a href="#" class="j-price-list-link">${$pgettext('event.tooltip', 'here')}</a>`
            return text.replace('%{link}', link)
        },
        appendToBody: false,
        active: true,
        placement: 'top-start',
    },
    shareEvent: {
        header: () => $pgettext('event.tooltip', 'Share the event') + '<span class="p-closer j-activate-event">&times;</span>',
        content: () => $pgettext('event.tooltip', 'View the access tools and share them with attendees to invite them to access their album'),
        appendToBody: true,
        active: true,
        placement: 'top-start',
    }
}